module.exports = __webpack_public_path__ + "static/insurance_agency-icon-bd2994939319645fa790c7339a300dea.png";